import { QGL_Lib } from "./QGL_Lib";
import { Mat_SamletFastEjendom } from "./DFQGLTypes";

export class MatQGL_Lib extends QGL_Lib {

  static EjerlavCache = new Map<number, Promise<string>>();
  async ejerlavsNavn(ejerlavskode: number): Promise<string | undefined> {
    if (!MatQGL_Lib.EjerlavCache.has(ejerlavskode)) {
      MatQGL_Lib.EjerlavCache.set(ejerlavskode, this.query(`
query {
  MAT_Ejerlav(
    virkningstid: "${new Date().toISOString()}"
    registreringstid: "${new Date().toISOString()}"
    where: { ejerlavskode: {eq: ${ejerlavskode} } }
  ) {
    nodes {
      ejerlavsnavn
    }
  }
}
      `, "MAT").then(result =>
        (result as { MAT_Ejerlav: { nodes: { ejerlavsnavn: string }[] } }
        ).MAT_Ejerlav.nodes[0]?.ejerlavsnavn ?? ""
      ));
    }
    return await MatQGL_Lib.EjerlavCache.get(ejerlavskode);
  }

  async AdresserPåJordstykke(matnr: string, ejerlavskode: number | string): Promise<AdresseJordstykkeResponse> {
    let isoNow = new Date().toISOString();
    let query = await this.query<AdresseJordstykkeResponse>(`
      query {
  MAT_Jordstykke(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { matrikelnummer: { eq: "${matnr}" }, ejerlavLokalId: { eq: "${ejerlavskode}" } }
  ) {
    nodes {
      matrikelnummer
      jordstykkeLiggerIEjerlav {ejerlavskode ejerlavsnavn}
      id_lokalId_22_Husnummer_jordstykke_ref {
        nodes {
          id_lokalId
          adgangsadressebetegnelse
          husnummerHoererTilIPostnummer {
            postnr
            navn
          }
          husnummerLiggerIKommuneinddeling {
            kommunekode
            navn
          }
          husnummerHarAdresser {
            nodes {
              id_lokalId
              adressebetegnelse
            }
          }
        }
      }
    }
  }
}
`);
    return query;
  }

  async JordstykkeOpslag(matnr: string, ejerlavskode: number | string): Promise<JordstykkeOpslagResponse> {
    let isoNow = new Date().toISOString();
    let query = await this.query<JordstykkeOpslagResponse>(`
query {
  MAT_Jordstykke(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { matrikelnummer: { eq: "${matnr}" }, ejerlavLokalId: { eq: "${ejerlavskode}" } }
  ) {
    nodes {
      centroideLiggerIndenForJordstykke {nodes{geometri{wkt}}}
			jordstykkeLiggerIEjerlav {
        ejerlavsnavn
        ejerlavskode
        
      }
      jordstykkeLiggerIMatrikelKommune {
        kommunekode
        kommunenavn
      }
      vejareal
      registreretAreal
      samletFastEjendomLokalId
    }
  }
}
`);
    return query;
  }

  async BestemtFastEjendom(bfeNr: string): Promise<{ MAT_SamletFastEjendom: { nodes: Mat_SamletFastEjendom[] } }> {
    let isoNow = new Date().toISOString();
    return this.query<{ MAT_SamletFastEjendom: { nodes: any[] } }>(`
query {
  MAT_SamletFastEjendom(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { BFEnummer: {eq: ${bfeNr} } status: {eq: "Gældende" }}
  ) {
    nodes {
      id_lokalId
      id_namespace
      BFEnummer
      status
      arbejderbolig
      erFaelleslod
      hovedejendomOpdeltIEjerlejligh
      landbrugsnotering
      udskiltVej
      forretningshaendelse
      forretningsomraade
      forretningsproces
      senesteSagLokalId
      paataenktHandling
      registreringFra
      registreringTil
      registreringsaktoer
      virkningFra
      virkningTil
      virkningsaktoer
      bygningPaaFremmedGrundFladeLiggerPaaSamletFastEjendom {
        nodes {
          BFEnummer
          status
          senesteSagLokalId
          ejerlejlighedErDelAfBygningPaaFremmedGrundFlade {
            nodes {
              BFEnummer
              status
              senesteSagLokalId
            }
          }
        }
      }
      bygningPaaFremmedGrundPunktLiggerPaaSamletFastEjendom {
        nodes {
          BFEnummer
          status
          senesteSagLokalId
          ejerlejlighedErDelAfBygningPaaFremmedGrundPunkt {
            nodes {
              BFEnummer
              status
              senesteSagLokalId
            }
          }
        }
      }
      ejerlejlighedErDelAfSamletFastEjendom {
        nodes {
          BFEnummer
          status
          senesteSagLokalId
        }
      }
      jordstykkeSamlesISamletFastEjendom (
        where: { status: { eq: "Gældende" } }
      ) {
        nodes {
          id_lokalId
          id_namespace
          status
          matrikelnummer
          delnummer
          registreretAreal
          vejareal
          vejarealberegningsstatus
          faelleslod
          brugsretsareal
          vandarealinkludering
          arealberegningsmetode
          arealbetegnelse
          arealtype
          forretningshaendelse
          forretningsomraade
          forretningsproces
          senesteSagLokalId
          skelforretningssagsLokalId
          supplerendeMaalingSagLokalId
          paataenktHandling
          registreringFra
          registreringTil
          registreringsaktoer
          virkningFra
          virkningTil
          virkningsaktoer
          stammerFraJordstykkeLokalId
          samletFastEjendomLokalId
          fredskov_areal
          fredskov_omfang
          jordrente_omfang
          klitfredning_areal
          klitfredning_omfang
          majoratsskov_nummer
          majoratsskov_omfang
          strandbeskyttelse_areal
          strandbeskyttelse_omfang
          centroideLiggerIndenForJordstykke {
            nodes {
              geometri {
                wkt
              }
              senesteSagLokalId
              status
            }
          }
          jordstykkeLiggerIEjerlav {
            ejerlavskode
            ejerlavsnavn
          }
          jordstykkeLiggerIMatrikelKommune {
            id_lokalId
            kommunenavn
          }
          jordstykkeLiggerIMatrikelRegion {
            id_lokalId
            regionsnavn
          }
          jordstykkeLiggerIMatrikelSogn {
            id_lokalId
          }
        }
      }
    }
  }
}
      `);
  }

  async SFEInformationForServitutErklaering(bfeNr: string): Promise<any> {
    let isoNow = new Date().toISOString();
    return this.query<any>(`
query {
  MAT_SamletFastEjendom(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { BFEnummer: {eq: ${bfeNr} } status: {eq: "Gældende" }}
  ) {
    nodes {
      BFEnummer
      status
      jordstykkeSamlesISamletFastEjendom {
        nodes {
          status
          matrikelnummer
          jordstykkeLiggerIEjerlav {
            ejerlavskode
            ejerlavsnavn
          }
        }
      }
      bygningPaaFremmedGrundFladeLiggerPaaSamletFastEjendom {
        nodes {
          BFEnummer
          status
        }
      }
      bygningPaaFremmedGrundPunktLiggerPaaSamletFastEjendom {
        nodes {
          BFEnummer
          status
        }
      }
    }
  }
}`);
  }


  async simpleBFENummerQuery(bfeNr: string): Promise<any> {
    return {
      ...(await this.simpleMATQuery(bfeNr)),
      ...(await this.simpleEJLQuery(bfeNr)),
      ...(await this.simpleBPFGQuery(bfeNr)),
      ...(await this.simpleBPFGPQuery(bfeNr))
    }
  }

  async simpleMATQuery(bfeNr: string): Promise<any> {
    let isoNow = new Date().toISOString();
    return this.query<any>(`
query {
  MAT_SamletFastEjendom(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { BFEnummer: {eq: ${bfeNr} } status: {eq: "Gældende" }}
  ) {
    nodes {
      BFEnummer
      status
    }
  }
}`, "MAT");
  }

  async simpleEJLQuery(bfeNr: string): Promise<any> {
    let isoNow = new Date().toISOString();
    return this.query<any>(`
query {
  MAT_Ejerlejlighed(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { BFEnummer: {eq: ${bfeNr} } status: {eq: "Gældende" }}
  ) {
    nodes {
      BFEnummer
      status
      samletFastEjendomLokalId
    }
  }
}`, "MAT");
  }

  async simpleBPFGQuery(bfeNr: string): Promise<any> {
    let isoNow = new Date().toISOString();
    return this.query<any>(`
query {
  MAT_BygningPaaFremmedGrundFlade(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { BFEnummer: {eq: ${bfeNr} } status: {eq: "Gældende" }}
  ) {
    nodes {
      BFEnummer
      status
      samletFastEjendomLokalId
    }
  }
}`, "MAT");
  }

  async simpleBPFGPQuery(bfeNr: string): Promise<any> {
    let isoNow = new Date().toISOString();
    return this.query<any>(`
query {
  MAT_BygningPaaFremmedGrundPunkt(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { BFEnummer: {eq: ${bfeNr} } status: {eq: "Gældende" }}
  ) {
    nodes {
      BFEnummer
      status
      samletFastEjendomLokalId
    }
  }
}`, "MAT");
  }
}


type AdresseJordstykkeResponse = {
  MAT_Jordstykke: {
    "nodes": {
      "matrikelnummer": "10t",
      "jordstykkeLiggerIEjerlav": {
        "ejerlavskode": 12651,
        "ejerlavsnavn": "Islev By, Islev"
      },
      "id_lokalId_22_Husnummer_jordstykke_ref": {
        "nodes": {
          "id_lokalId": "0a3f507d-80bb-32b8-e044-0003ba298018",
          "adgangsadressebetegnelse": "Horsevænget 1, 2610 Rødovre",
          "husnummerHoererTilIPostnummer": {
            "postnr": "2610",
            "navn": "Rødovre"
          },
          "husnummerLiggerIKommuneinddeling": {
            "kommunekode": "0175",
            "navn": "Rødovre"
          },
          "husnummerHarAdresser": {
            "nodes":
            {
              "id_lokalId": "0a3f50a6-8d1a-32b8-e044-0003ba298018",
              "adressebetegnelse": "Horsevænget 1, st., 2610 Rødovre"
            }[]
          }
        }[]
      }
    }[]
  }
}

type JordstykkeOpslagResponse = {
  "MAT_Jordstykke": {
    "nodes":
    {
      "centroideLiggerIndenForJordstykke": {
        "nodes":
        {
          "geometri": {
            "wkt": "POINT (716953.849 6177931.115)"
          }
        }[]
      },
      "jordstykkeLiggerIEjerlav": {
        "ejerlavsnavn": "Islev By, Islev",
        "ejerlavskode": 12651
      },
      "jordstykkeLiggerIMatrikelKommune": {
        "kommunekode": "0175",
        "kommunenavn": "Rødovre Kommune"
      },
      "vejareal": 6501,
      "registreretAreal": 43125,
      "samletFastEjendomLokalId": "8776912"
    }[]
  }
}